<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
                    <path
                        d="M21.6979 14.5332V6.5725M21.6979 14.5332C21.6979 15.4126 20.9851 16.1254 20.1057 16.1254H2.59214C1.71283 16.1254 1 15.4126 1 14.5332M21.6979 14.5332V2.59214M21.6979 6.5725H1M21.6979 6.5725V2.59214M1 6.5725V14.5332M1 6.5725V2.59214M1 14.5332V2.59214M21.6979 2.59214C21.6979 1.71283 20.9851 1 20.1057 1H2.59214C1.71283 1 1 1.71283 1 2.59214M15.3293 12.145H17.7175"
                        stroke="#44A561" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Cartão</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Nome do titular</div>
                            <div class="item__container--value">{{ nome_titular }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Número do Cartão</div>
                            <div class="item__container--value">{{ numero_cartao }}</div>
                            <div class="item__container--pill" :class="countCard > 5 ? 'red' : 'green'">{{ countCard }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Bandeira</div>
                            <div class="item__container--value">{{ bandeira }}</div>
                            <div class="item__container--pill">
                                <img :src="creditCardImage" :alt=bandeira>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Emissor</div>
                            <div class="item__container--value">{{ emissor }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnalysisTableCard',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        bandeira() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.brand ? this.data.risk_body.credit_card.brand : '---';
        },
        numero_cartao() {
            return this.data && this.data.card_first_digits && this.data.card_last_digits ?
            this.data.card_first_digits + '**** ****' + this.data.card_last_digits : '---';
        },
        emissor() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.issuer && this.data.risk_body.credit_card.issuer.name ? this.data.risk_body.credit_card.issuer.name : '---';
        },
        nome_titular() {
            return this.data && this.data.client && this.data.client.name ? this.data.client.name : '---';
        },
        creditCardImage() {
            const brand = this.bandeira.toLowerCase();
            const imageMap = {
                visa: 'visa.png',
                mastercard: 'master.png',
                amex: 'amex.png',
                discover: 'discover.png',
            };

            return imageMap[brand] ? require(`@assets/images/cards/${imageMap[brand]}`) : require('@assets/images/cards/default.svg');
        },
        countCard() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer.count.card
        },

    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #44A561;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;
                        cursor: pointer;

                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.green {
    background: rgba(68, 165, 97, 0.10);
    color: #44A561;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>